import type { ScormRuntimeVersion } from '../transport/common'
import { ScormSuspendData, IInteractionData } from '../transport/types'
import type {
  CompletionStatus,
  ILmsEvent,
  ILmsLearnerInfo,
  ILmsProvider,
  IProviderConfig,
  IScore,
  LmsType,
  SuccessStatus,
} from '../types'

export abstract class BaseLmsProvider implements ILmsProvider {
  abstract readonly type: LmsType

  protected config: IProviderConfig | null = null
  protected connected = false
  protected learnerInfo: ILmsLearnerInfo = {}

  abstract initialize(config: IProviderConfig): Promise<boolean>
  abstract terminate(): Promise<void>

  isConnected(): boolean {
    return this.connected
  }

  getLearnerInfo(): ILmsLearnerInfo {
    return { ...this.learnerInfo }
  }

  // Default implementations - override in subclasses as needed
  async setSuspendData(_data: ScormSuspendData): Promise<void> {
    // No-op by default
  }

  async getSuspendData(): Promise<ScormSuspendData | null> {
    return null
  }

  getSuspendDataSync(): ScormSuspendData | null {
    return null
  }

  async setProgress(_value: number): Promise<void> {
    // No-op by default
  }

  async setScore(_score: IScore): Promise<void> {
    // No-op by default
  }

  async setCompletionStatus(_status: CompletionStatus): Promise<void> {
    // No-op by default
  }

  async setSuccessStatus(_status: SuccessStatus): Promise<void> {
    // No-op by default
  }

  async setLocation(_location: string): Promise<void> {
    // No-op by default
  }

  async trackEvent(_event: ILmsEvent): Promise<void> {
    // No-op by default
  }

  async commit(): Promise<void> {
    // No-op by default
  }

  // Synchronous — called from scormInteractions.ts hot path.
  setInteraction(_index: number, _data: IInteractionData): void {
    // No-op by default
  }

  // Returns SCORM version for interaction field-name selection (1.2 vs 2004 semantics).
  getScormVersion(): ScormRuntimeVersion {
    return 'none'
  }

  protected setLearnerInfo(info: Partial<ILmsLearnerInfo>): void {
    this.learnerInfo = { ...this.learnerInfo, ...info }
  }

  sendAnalyticsViaBeacon(_statements: ILmsEvent[]): boolean {
    return false
  }
}
